const MaxLength = {
  session_liveqa_question: 1000,
  session_liveqa_reply: 1000,
  session_poll: 300,
  session_poll_option: 100,
  social_post: 2000,
  social_comment: 2000,
  social_poll_option: 100,
  community_create_post_title: 100,
  community_create_post_desc: 2000,
  community_intro_desc: 120,
  community_meetup_desc: 250,
  community_job_desc: 250,
  community_message: 2000,
  chat_message: 2000,
  chat_meeting_note: 50,
  note_add: 2000,
  support_chat: 1000,
  common_comment_reply: 2000,
  common_name: 250,
  common_desc: 2000,
  gallery_caption: 2000,
  activity_title: 100,
  activity_desc: 1500,
  session_title: 200,
  session_description: 10000
};

export default MaxLength;
